export const COMMON_HTTP_I18N_PREFIX = "common.http";

export const COMMON_HTTP_I18N_KEYS = {
  authentication_failed_or_expired: "authentication_failed_or_expired"
};




// WEBPACK FOOTER //
// ./src/common/i18n/Commoni18nConstants.js